import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import {
  getEmpresaSlugFromLoginPath,
  getLoginCompanyImageUrl,
  useLoginCompanyConfig,
} from '../../app/modules/auth/core/loginCompanyConfig'
import { useAPIVersion } from './useAPIVersion'
import { LogoComponent } from 'app/components'

export const AuthLayout = () => {
  const { data: softwareInfo } = useAPIVersion()
  const location = useLocation()
  const empresaSlug = getEmpresaSlugFromLoginPath(location.pathname)
  const { data: loginCompanyConfig, isLoading: isLoadingCompany } =
    useLoginCompanyConfig(empresaSlug)
  const authBackgroundImage = loginCompanyConfig?.image || '/media/misc/auth-bg.png'
  // Login de empresa ainda sem configuração (ex.: logout por inatividade, sem pré-carga):
  // lateral e logo neutros em vez de piscar os da Lauduz até a marca da empresa chegar.
  const isCompanyPending = !!empresaSlug && isLoadingCompany

  useEffect(() => {
    document.body.style.backgroundImage = 'none'
    return () => {}
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid min-vh-100 auth-layout'>
      <div className='d-flex flex-column flex-column-fluid flex-center w-lg-50 p-10 order-2 order-lg-1'>
        <div className='d-flex justify-content-center flex-column-fluid flex-column w-100 mw-450px'>
          <div className='auth-layout__brand d-flex justify-content-center mb-10'>
            {isCompanyPending ? (
              <div className='h-50px' aria-hidden='true' />
            ) : (
              <LogoComponent src={loginCompanyConfig?.logo} className='h-50px' />
            )}
          </div>
          <Outlet />
          {softwareInfo && (
            <div className='text-center text-gray-700 fs-8 mt-6'>
              <span>
                {softwareInfo.softwareName} | {softwareInfo.vendorName} | v{softwareInfo.version} |{' '}
                {softwareInfo.environment}
              </span>
            </div>
          )}
        </div>
      </div>
      <div
        className='auth-layout__aside d-none d-lg-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2'
        style={
          isCompanyPending
            ? undefined
            : { backgroundImage: `url("${getLoginCompanyImageUrl(authBackgroundImage)}")` }
        }
      ></div>
    </div>
  )
}
